import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { DRIVER_LOG_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin, createLoadParameterReducer,
} from '../../utils/getCrudConfig';
import {
  LOAD_DRIVER_LOG_BY_ID, LOAD_DRIVER_LOG_LIST,
  LOAD_DRIVER_LOG_LIST_ALL, LOAD_ORDER_SERVICE_BY_ID, LOAD_ORDER_SERVICE_LIST, LOAD_TRANSPORT_LIST,
  LOAD_TRANSPORT_LIST_BY_ID,
} from './actions';
import { LOAD_CARRIER_BY_ID, LOAD_CARRIER_LIST } from '../RegionRegistry/actions';

const initialState = {
  driverLogList: [],
  driverLogListAll: [],
  driverLogListMeta: {},
  loadingDriverLogList: false,
  loadingDriverCard: false,
  driverCard: {},
  loadingTransportList: false,
  transportList: [],
  transportListMeta: {},
  loadingOrderServiceList: false,
  orderServiceList: [],
  orderServiceListMeta: {},
  currentOrderService: {},
  loadingCurrentOrderService: false,
  loadingCarrierList: false,
  carrierList: [],
  carrierListMeta: {},
  currentCarrier: {},
  loadingCurrentCarrier: false,
  currentTransport: {},
  loadingCurrentTransport: false,
  loadingDriverLogListAll: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST, 'driverLogList', 'loadingDriverLogList'),
  ...createLoadListReducerWithBegin(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL, 'driverLogListAll', 'loadingDriverLogListAll'),
  ...createLoadListReducerWithBegin(DRIVER_LOG_MODULE + LOAD_TRANSPORT_LIST, 'transportList', 'loadingTransportList'),
  ...createLoadParameterReducer(DRIVER_LOG_MODULE + LOAD_TRANSPORT_LIST_BY_ID, 'currentTransport', 'loadingCurrentTransport'),
  ...createLoadByIdReducer(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_BY_ID, 'driverCard', 'loadingDriverCard'),
  ...createLoadListReducerWithBegin(DRIVER_LOG_MODULE + LOAD_ORDER_SERVICE_LIST, 'orderServiceList', 'loadingOrderServiceList'),
  ...createLoadParameterReducer(DRIVER_LOG_MODULE + LOAD_ORDER_SERVICE_BY_ID, 'currentOrderService', 'loadingCurrentOrderService'),
  ...createLoadListReducerWithBegin(DRIVER_LOG_MODULE + LOAD_CARRIER_LIST, 'carrierList', 'loadingCarrierList'),
  ...createLoadParameterReducer(DRIVER_LOG_MODULE + LOAD_CARRIER_BY_ID, 'currentCarrier', 'loadingCurrentCarrier'),
}, initialState);

export default reducer;

export const getDriverData = createSelector(
  [state => state[DRIVER_LOG_MODULE]],
  state => {
    const {
      driverLogList,
      loadingDriverLogList,
      driverLogListMeta,
      loadingDriverCard,
      driverCard,
      transportList,
      loadingTransportList,
      transportListMeta,
      loadingOrderServiceList,
      orderServiceList,
      orderServiceListMeta,
      currentOrderService,
      loadingCurrentOrderService,
      loadingCarrierList,
      carrierList,
      carrierListMeta,
      currentCarrier,
      loadingCurrentCarrier,
      currentTransport,
      loadingCurrentTransport,
      loadingDriverLogListAll,
    } = state;

    return {
      loadingDriverLogListAll,
      loadingCarrierList,
      carrierList,
      carrierListMeta,
      currentOrderService,
      loadingCurrentCarrier,
      currentCarrier,
      loadingCurrentOrderService,
      driverLogList,
      loadingDriverLogList,
      driverLogListMeta,
      loadingDriverCard,
      driverCard,
      transportList,
      loadingTransportList,
      transportListMeta,
      loadingOrderServiceList,
      orderServiceList,
      orderServiceListMeta,
      currentTransport,
      loadingCurrentTransport,
    };
  },
);
